<template>
  <div>
    <!-- Buttons add folder, add file-->
    <div v-if="!is_my_board">
      <div class="row">
        <div class="col-6 mt-2">
          <label>{{ this.path_folder }}</label>
          <span v-if="loadingIconState">
            <i class="fa-2x fa-solid fa-spinner fa-spin-pulse"></i> {{ __("misc.loading") }}
          </span>
        </div>
        <div class="col-6 d-flex justify-content-end">
          <div v-if="user_can_edit_folder">
            <a href="#" @click="openAddFolder()" class="btn btn--green">
              {{ __("views.Dashboard.new_folder") }}
            </a>
          </div>

          <div class="ml-2" v-if="user_can_edit_file">
            <a href="#" @click="openAddFile()" class="btn btn--green">
              {{ __("views.Dashboard.new_file") }}
            </a>
          </div>
          <div class="ml-2" v-if="user_can_edit_file">
            <a href="#" @click="openAddLink()" class="btn btn--green">
              {{ __("views.Dashboard.new_link") }}
            </a>
          </div>
        </div>
      </div>
    </div>



    <!-- new -->
    <div class="list-head d-none d-md-block">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-12">{{ __("views.Activities.name") }}</div>
        <div class="col-lg-3 col-md-12 col-12">{{ __("forms.RevisionChart.updated_at") }}</div>
        <div class="col-lg-3 col-md-12 col-12">{{ __("misc.actions") }}</div>
      </div>
    </div>
    <div class="list-content mt-2">
      <!-- previus folder folder-->
      <div class="single--item" v-if="folder_id !== null">
        <div class="row" @click="readFolder(previous_folder_id)">
          <div class="col-lg-6 col-md-12 col-12">
            <div class="single--item-document">
              <i class="fas fa-arrow-up"></i>
              {{ __("views.Dashboard.parent_folder") }}
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-changes"></div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-actions"></div>
          </div>
        </div>
      </div>

      <!-- folders -->
      <div class="single--item" v-for="folder in folder_list" :key="folder.id">
        <div class="row" @click="readFolder(folder.id)">
          <div class="col-lg-6 col-md-12 col-12">
            <div class="single--item-document">
              <i class="fas fa-folder colored-icon"></i>
              {{ folder.name }}
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-changes"></div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-actions  justify-content-center align-center" v-if="!is_my_board">
              <div class="d-flex ml-3" v-if="folder.canEdit">
                <a class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1" href="#"
                  @click.stop="editFolder(folder.id)">
                  <i class="fas fa-pencil"></i> </a>&nbsp;
                <a class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1" href="#"
                  @click.stop="deleteFolder(folder)">
                  <i class="fas fa-trash"></i> </a>&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- files -->
      <div class="single--item" v-for="file in file_list" :key="file.id">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div v-if="file.canView" class="single--item-document">
              <a href="#" @click="viewFile(file.id, file.url, 1)"><i class="fa-solid fa-file colored-icon"></i>&nbsp;{{ file.name }}
              </a>&nbsp;
            </div>
            <div v-else class="single--item-document">
              <span><i class="fa-solid fa-file colored-icon"></i>&nbsp;{{ file.name }}</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-changes">
              <span>{{ file.lastUpdate }}</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-actions justify-content-center align-center" v-if="!is_my_board">
              <div class="d-flex ml-3">
                <a class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1" v-if="file.canEdit" href="#" @click="moveFile(file.id)">
                  <i class="fas fa-pencil"></i> </a>&nbsp;
                <a class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1" v-if="file.canEdit" href="#" @click="deleteFile(file.id)">
                  <i class="fas fa-trash"></i> </a>&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- links -->
      <div class="single--item" v-for="(link, linkIndex) in link_list" :key="linkIndex">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="single--item-document">
              <span @click="openLink(link.url)" class="pointer-icon"><i class="far fa-link"></i>&nbsp;{{ link.name
              }}</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-changes"></div>
          </div>
          <div class="col-lg-3 col-md-12 col-12">
            <div class="single--item-actions" v-if="!is_my_board">
              <span>
                <a v-if="link.canEdit" href="#" @click="moveLink(link.id)">
                  <i class="fas fa-edit"></i> </a>&nbsp;
                <a v-if="link.canEdit" href="#" @click="deleteLink(link.id)">
                  <i class="fas fa-trash"></i> </a>&nbsp;
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.folder_id = this.parent_folder_id > 0 ? this.parent_folder_id : null;
    this.readFolder(this.folder_id);
  },
  props: {
    model: {
      type: String,
      required: true,
    },
    parent_folder_id: {
      type: Number,
      required: true,
    },
    module_name: {
      type: String,
      required: true,
    },

    model_id: {
      type: Number,
      required: true,
    },
    add_folder_url: {
      type: String,
      required: true,
    },
    add_file_url: {
      type: String,
      required: true,
    },
    add_link_url: {
      type: String,
      required: true,
    },
    user_can_edit_folder: {
      type: Boolean,
      required: true,
    },
    user_can_edit_file: {
      type: Boolean,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    is_my_board: {
      type: Boolean,
      required: true,
    },
    category_folders: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loadingIconState: false,
      folder_list: {},
      file_list: {},
      link_list: {},
      folder_id: null,
      previous_folder_id: null,
      path_folder: "/",
    };
  },
  methods: {
    editFolder(folder) {
      app.__vue__.$refs.vue_popup.toggle(
        "edit",
        "/media-structure/action/edit-folder/" +
        folder +
        "?module=" +
        this.module_name +
        "&model_id=" +
        this.model_id,
      );
    },

    deleteFolder(folder) {
      Vue.swal
        .fire({
          title: "Vuoi eliminare la cartella " + folder.name + "?",
          text: "Il suo contenuto verrà cancellato",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/media-structure/action/destroy/" + folder.id)
              .then((response) => {
                this.readFolder(this.folder_id);
              });
          }
        });
    },
    openAddFolder() {
      app.__vue__.$refs.vue_popup.toggle(
        "Aggiungi cartella",
        this.add_folder_url +
        "&module=" +
        this.module_name +
        "&folder=" +
        this.folder_id +
        "&model_id=" +
        this.model_id +
        "&category=" +
        this.category_folders,
      );

    },
    openAddLink() {
      app.__vue__.$refs.vue_popup.toggle(
        "Aggiungi cartella",
        this.add_link_url +
        "&module=" +
        this.module_name +
        "&folder=" +
        this.folder_id +
        "&category=" +
        this.category_folders,
      );

    },
    openAddFile() {
      app.__vue__.$refs.vue_popup.toggle(
        "Aggiungi file",
        this.add_file_url +
        "&folder=" +
        this.folder_id +
        "&module=" +
        this.module_name +
        "&category=" +
        this.category_folders,
      );

    },

    moveFile(file) {
      app.__vue__.$refs.vue_popup.toggle(
        "Move File",
        "/media-structure/action/move-file/" +
        file +
        "/media?model_class=" +
        this.model +
        "&module=" +
        this.module_name +
        "&model_id=" +
        this.model_id +
        "&folder=" +
        this.folder_id +
        "&category=" +
        this.category_folders,
      );
    },
    moveLink(link) {
      app.__vue__.$refs.vue_popup.toggle(
        "Move File",
        "/media-structure/action/move-link/" +
        link +
        "/link?model_class=" +
        this.model +
        "&module=" +
        this.module_name +
        "&model_id=" +
        this.model_id +
        "&folder=" +
        this.folder_id +
        "&category=" +
        this.category_folders,
      );
    },

    viewFile(file, url) {
      window.open(url, "_blank");
    },
    openLink(url) {
      Vue.swal
        .fire({
          title: "Attenzione",
          text: "Stai per uscire dalla piattaforma HRTools, vuoi continuare?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            let win = window.open(url, "_blank");
          }
        });
    },

    deleteFile(file) {
      Vue.swal
        .fire({
          title: "Vuoi eliminare questo file?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/media-structure/action/destroy-file/" + file + "/media")
              .then((response) => {
                this.readFolder(this.folder_id);
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },
    deleteLink(link) {
      Vue.swal
        .fire({
          title: "Vuoi eliminare questo link?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(
                "/media-structure/action/destroy-link/" + link + "/media-link",
              )
              .then((response) => {
                this.readFolder(this.folder_id);
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },

    readFolder(folder) {
      this.folder_id = folder;
      this.loadingIconState = true;
      let params = {
        folder: folder,
        model: this.model,
        model_id: this.model_id,
        category:
          this.category_folders == "null" ? null : this.category_folders,
      };

      axios
        .get("/api/media-models-folders-files", { params: params })
        .then((response) => {
          this.file_list = response.data.files;
          this.folder_list = response.data.folders;
          this.link_list = response.data.links;
          //set previous folder
          this.previous_folder_id = response.data.previous_folder;
          this.path_folder = response.data.pathFolder;
          this.loadingIconState = false;
        })
        .catch(function (error) {
          this.loadingIconState = false;
          alert(error);
        });
    },
  },
};
</script>

<style>
.pointer-icon {
  cursor: pointer;
}

.list-content{
  height:100% !important;
}

.list-head .col-12:not(:last-of-type) {
  border-right: none !important;
}

.list-content .col-12:not(:last-of-type) {
  border-right: none !important;
}
</style>
